const ZOOM_SPEED_TO_DURATION_MS = {
  slow: 6000,
  medium: 3500,
  fast: 2000,
};

function initVideoPosterZoom(root = document) {
  const sections = root.querySelectorAll('deferred-media.video-section__media[data-enable-zoom="true"]');
  if (!sections.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        const scalePercent = parseInt(el.dataset.zoomScale || '8', 10);
        const speedKey = (el.dataset.zoomSpeed || 'slow');
        const duration = ZOOM_SPEED_TO_DURATION_MS[speedKey] || ZOOM_SPEED_TO_DURATION_MS.slow;

        el.style.setProperty('--zoom-scale', (1 + scalePercent / 100).toString());
        el.style.setProperty('--zoom-duration', `${duration}ms`);

        if (entry.isIntersecting) {
          el.classList.add('is-inview');
        } else {
          el.classList.remove('is-inview');
        }
      });
    },
    { rootMargin: '0px 0px -20% 0px', threshold: 0.15 }
  );

  sections.forEach((el) => observer.observe(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initVideoPosterZoom());
} else {
  initVideoPosterZoom();
}

// Re-init on Shopify section re-renders in the editor (if applicable)
document.addEventListener('shopify:section:load', (e) => initVideoPosterZoom(e.target));
document.addEventListener('shopify:section:reorder', (e) => initVideoPosterZoom(e.target));


